import { AllModulesTagName } from "@me-team/common/src/utils/enums";
import AccessService from "../../services/AccessService";
import { useContext } from "react";
import { AccessContext } from "../components/App/App";

export const useModulesAccess = (modules: AllModulesTagName[]): boolean => {
    const { isReady } = useContext(AccessContext);
    const accessService = AccessService.getInstance();

    if (!isReady) return false;

    return accessService.areModulesActive(modules);
};
